<template>
  <nav class="landing-bar">
    <div class="inner-landing-bar">
      <div class="landing-bar-left">
        <a href="/" class="navbar-brand">
          <img class="nav-logo" src="../../img/eflexLogo.png" alt="EFLEX Logo" />
        </a>
        <div class="nav-bar-links">
          <!-- <li class="nav-bar-item">
            <a
              href="/dashboard"
              :class="getRoute=='dashboard' ? 'nav-bar-link nav-bar-link-active' : 'nav-bar-link'"
            >Dashboard</a>
          </li> -->
        </div>
      </div>
      <div class="landing-bar-right">
          <a href="/login" class="login-button">Log In</a>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  computed: {
    getRoute() {
      return this.$route.name;
    },
  },
};
</script>

<style lang="scss">
@import "../../sass/main.scss";

.landing-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  width: 100%;
  background: #263858;
  box-shadow: 0 1px 4px 0 hsla(0, 0%, 0%, 0.2);
}

.inner-landing-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
//   padding: 0 30px;
  width: 100%;
}

.landing-bar-left {
    display: flex;
}

.nav-bar-links {
  display: flex;
  align-items: center;
}

.nav-bar-item {
  list-style: none;
}

.nav-logo {
  width: 150px;
  margin-right: 10px;
}

.nav-bar-link,
.nav-bar-link-active {
  color: $black;
  font-size: 1em;
  font-weight: 700;
  margin-left: 50px;
  padding: 10px 0;
  letter-spacing: 1.2px;
  position: relative;
}

.login-button {
    color: #fff !important;
    margin: 0 20px;
    letter-spacing: 1.2px;
    border: 1px solid #fff;
    border-radius: 10px;
    padding: 10px 30px;
}

.signin-button {
    color: #fff;
    background: $green2;
    padding: 10px 20px;
    border-radius: 20px;
    margin: 0 20px;
    font-weight: 700;
    letter-spacing: 1.2px;
}

.signin-button:hover {
    color: #fff;
    text-decoration: none;
    background: hsl(144, 58%, 40%)
}
</style>